import {AB_TEST_ACTIVATION_VISUALIZATION} from '@aboutyou/feature-flags';
import {lazy} from '@aboutyou/lazy-imports';
import React from 'react';
import {createRoot} from 'react-dom/client';

export const AbTestActivationVisualization = ({
  isEnabled,
}: {
  isEnabled: boolean;
}) => {
  if (!isEnabled) {
    return null;
  }
  return <LazyAbTestActivationVisualization />;
};

const LazyAbTestActivationVisualization = lazy(() =>
  import('./AbTestActivationVisualization.eager').then(mod => ({
    default: mod.AbTestActivationVisualization,
  })),
);

export const renderAbTestActivationVisualization = () => {
  if (isVisualizationEnabled()) {
    const abTestVisualizationRoot = document.createElement('DIV');
    document.body.prepend(abTestVisualizationRoot);
    const root = createRoot(abTestVisualizationRoot);
    root.render(<AbTestActivationVisualization isEnabled />);
  }
};

const isVisualizationEnabled = () => {
  const isEnabledByFeatureFlagifyLocalStorageValue = localStorage.getItem(
    AB_TEST_ACTIVATION_VISUALIZATION,
  );
  return isEnabledByFeatureFlagifyLocalStorageValue === 'true';
};
